import {
  usePageNumberFromUrl,
  usePerPageValueFromUrl,
  useSortValueFromUrl,
} from 'idsk-react-components';
import { useParams } from 'react-router';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import { defaultPerPageValue, perPageDataArray } from '../../../../../constants/PaginationPerPageConstants';
import { fetchTerminHistoriaZmienPage } from '../../../../../client/termin/terminHistoriaZmienClient';
import TerminHistoriaZmienPage from '../../../../../model/TerminHistoriaZmienPage';

interface ReturnType {
  terminHistoriaZmienPage: TerminHistoriaZmienPage;
  terminHistoriaZmienStatus: ClientStatus;
  pageNumber: number;
  reloadTerminHistoriaZmien;
}

export default (): ReturnType => {
  const { terminUuid } = useParams<{ terminUuid: string }>();
  const { page } = usePageNumberFromUrl();
  const { sort } = useSortValueFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);

  let sortDirection;
  const sortBy = sort[0] === '' ? undefined : sort[0];

  if (sort[1] === '') {
    sortDirection = undefined;
  } else if (sort[1] === 'asc') {
    sortDirection = 'ASC';
  } else {
    sortDirection = 'DESC';
  }

  const {
    data: terminHistoriaZmienPage,
    status: terminHistoriaZmienStatus,
    refetch: reloadTerminHistoriaZmien,
  } = useClientFetch(
    fetchTerminHistoriaZmienPage,
    [terminUuid,
      page,
      perPageValue,
      sortBy,
      sortDirection,
    ],
    [
      sortDirection,
      sortBy,
      page,
      perPageValue,
    ],
  );

  return <ReturnType>{
    terminHistoriaZmienPage,
    terminHistoriaZmienStatus,
    pageNumber: page,
    reloadTerminHistoriaZmien,
  };
};
